import React, {useState, useEffect, useRef, useContext, useMemo} from 'react';
import { message, Radio, Checkbox, Select, Col, Input, InputNumber, Upload, Button, Divider, Popover, Empty, Image, Spin } from 'antd';
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons';
import Utils from '@utils/utils'
import API from '@api/api'
import { AppContext } from '@utils/AppContext';
import { GenerateContext } from "@utils/GenerateContext"
import MoreScenePopoverContent from '@view/compoents/MoreScenePopoverContent/MoreScenePopoverContent'
import styles from './selectScene.module.scss'
import CustomScene from '../customScene/customScene';
import { IMAGE_TYPE } from "@utils/CONST"
import VersionTips from '../customScene/components/VersionTips';

const SceneItem = (props) => {
    const {scene, selectedImg, selectImgClick, onMoreSceneChange, sceneName} = props
    const [moreSceneModalOpen, setMoreSceneModalOpen] = useState(false)
    const { setBgImage } = useContext(GenerateContext);

    const selectSceneClick = () => {
        if (scene?.subList && scene?.subList?.length > 0) {
            setMoreSceneModalOpen(true)
            selectImgClick(scene.name, scene.attr?.version)
        } else {
            selectImgClick(scene.name, scene.attr?.version)
        }
    }

    const onChange = (...args) => {
        onMoreSceneChange(scene.id, ...args)
        setMoreSceneModalOpen(false)
    }

    const onOpenChange = (value) => {
        if (!value) setMoreSceneModalOpen(false)
    }

    return (
        <Popover
            placement="topLeft"
            content={<MoreScenePopoverContent sceneList={scene?.subList} selectedName={selectedImg} onChange={onChange}/>}
            open={moreSceneModalOpen}
            arrow={false}
            overlayInnerStyle={{ padding: 0 }}
            trigger={"click"}
            onOpenChange={onOpenChange}
        >
            <div onClick={selectSceneClick} className={sceneName==scene.name?`${styles.selectedImg} ${styles.sceneItem}` : styles.sceneItem} >
                <div className={styles.sceneItemImg}>
                    <Image
                        width={"100%"}
                        height={"100%"}
                        style={{objectFit: 'cover'}}
                        preview={false}
                        src={`${Utils.addVersionParamToURL(scene.imageUrl, 'v', scene?.attr?.version)}&x-oss-process=image/format,webp`}
                    />
                </div>
                {scene.attr.recent === 1?<i className={styles.new_icon}></i>: null}
                <p className={styles.scene_title}>{scene.attr.title}</p>
                {
                    scene.subList?.length > 0 &&
                    <div className={styles.more_scene_handler}>
                        <i className={styles.more_scene_handler_img}></i>
                    </div>
                }
            </div>
        </Popover> 
    )
}

const SelectScene = (props) => {
    const { filteredBgListRef, setScenelList, setScenelList2, scenelDate2 } = useContext(AppContext);
    const {
        imageType,
        setBgImage,
        setSceneDirection,
        bgStyle,
        definedFlag,
    } = useContext(GenerateContext);

    const [selectedImg, setSelectedImg] = useState();
    const orginModelBgListRef = useRef([])
    const [loading, setLoading] = useState(true)
    const [modelbgList, setModelbgList] = useState([]);
    const modelbgListRef = useRef();
    const [initialSlide, setInitialSlide] = useState(0)
    const [once, setOnce] = useState(true)
    const showNum = props.sceneType == IMAGE_TYPE.COMMODITY?8:5 // 侧边栏测试几个
    const serachNum = props.sceneType == IMAGE_TYPE.COMMODITY?9:6 // 替换第一个时候遍历前多少个

    const [bgCategoryData, setBgCategoryData] = useState([])
    const [selectsceneType, setSelectsceneType] = useState('全部')

    const isDefaultStyle = useMemo(() => {
        if(props.title == '预设风格') return true
    })

    const customSceneAvailable = useMemo(() => {
        if (props.sceneType == IMAGE_TYPE.COMMODITY) return true
        if (props.sceneType == IMAGE_TYPE.MODEL) return true
        else {
            return API.url != 'https://photostudio.arcsoft.com.cn' && API.url != 'http://canary.ps.arcsoftbiz.com'
        }
    }, [props.sceneType])

    useEffect(() => {
        if (imageType == IMAGE_TYPE.MODEL) {
            if (definedFlag == 1) { // 模特切到自定义场景需要清除画布背景
                setBgImage()
                return
            }
            let foundItem = false
            let backgroundType = 0
            if(scenelDate2?.length > 0) {
                for (let i = 0; i < scenelDate2.length; i++){
                    const item = scenelDate2[i]
                    if (item.name == "00_random") continue
                    if (item.name == bgStyle) {
                        foundItem = item
                        backgroundType = item.attr.backgroundType
                        break
                    }
                    if (item.subList) {
                        const item2 = item.subList.find(item => item.name == bgStyle)
                        if (item2) {
                            foundItem = item2
                            backgroundType = item.attr.backgroundType
                            break
                        }
                    }
                }
            }
            if (foundItem && backgroundType == 1) {
                setBgImage(Utils.getImgUrlWithWebp(foundItem.imageUrl))
            } else {
                setBgImage()
            }
        }
    }, [imageType, bgStyle, scenelDate2, definedFlag])

    useEffect(() => {
        setLoading(true)
        let getBackgroundApi = props.sceneType == IMAGE_TYPE.COMMODITY ?
                    API.commodityBackgroundList : API.modelBackgroundList
        let params = props.clothCategory ? { categoryId: props.clothCategory, imageType: imageType } : {imageType: imageType, sceneType: selectsceneType == '全部'? '': selectsceneType}
        getBackgroundApi(params).then((res) => {
            if(res.code == 0) {
                if (res.data?.length == 0) {
                    setInitialSlide(0)
                    setModelbgList([])
                    orginModelBgListRef.current = []
                    return
                }
                let arr1 = []
                let arr2 = []
                if(imageType == IMAGE_TYPE.MODEL) {
                    res.data.map((item) => {
                        if(item.attr.backgroundType == 0) { // 预设场景
                            if(item.name == '00_keep') {
                                arr1.splice(1, 0, item) //始终将保留场景放在第一位
                            } else {
                                arr1.push(item)
                            }
                        } else {
                            if(item.attr.title == '窗幔布艺') { // 过滤掉窗幔布艺的随机icon
                                let obj = {
                                    ...item,
                                    subList: item.subList.filter(item => item.name !== '00_drapery_background_random')
                                }
                                arr2.push(obj)
                            } else {
                                arr2.push(item)
                            }
                        }
                    })
                } else {
                    arr1 = [...res.data.filter(item => item.name !== '00_keep')];
                    arr2 = [...res.data]
                }
                arr2.unshift(arr1[0])

                let resList = isDefaultStyle?arr1:arr2
                setScenelList(arr1)
                setScenelList2(arr2)

                orginModelBgListRef.current = JSON.parse(JSON.stringify(res.data))
                let arr = resList;
                let name = (isDefaultStyle && imageType == IMAGE_TYPE.MODEL)?arr[2].name: arr[1].name; // 默认选第一项
                let version = arr[0].attr?.version; // 算法需要version
                if (props.sceneName) {
                    setOnce(false);
                    name = props.sceneName;
                    let found = false;
                    let indexToReplace = -1; // 初始化要替换的项的索引为-1
                  
                    // 检查前9个元素是否包含 props.sceneName 对应的项
                    for (let i = 0; i < Math.min(arr?.length, 9); i++) {
                      if (arr[i].name == name) {
                        found = true;
                        version = arr[i].attr?.version; // 算法需要version
                        break;
                      }
                    }
                  
                    if (!found) {
                      // 查找数组中 props.sceneName 对应的项，并记录索引
                      for (let i = 0; i < arr?.length; i++) {
                        if (arr[i].name == name) {
                          indexToReplace = i;
                          version = arr[i].attr?.version; // 算法需要version
                          break;
                        }
                        if (arr[i].subList) {
                          let subList = arr[i].subList;
                          for (let k = 0; k < subList?.length; k++) {
                            if (subList[k].name == name) {
                              arr[i].name = subList[k].name;
                              arr[i].imageUrl = subList[k].imageUrl;
                              version = subList[k].attr?.version; // 算法需要version
                              indexToReplace = i;
                              break;
                            }
                          }
                        }
                        if (indexToReplace !== -1) {
                          break;
                        }
                      }
                    }
                  
                    if (indexToReplace !== -1) {
                      // 将找到的项替换到数组下标1的位置
                      const replaceIndex = (isDefaultStyle && imageType == IMAGE_TYPE.MODEL) ? 2 : 1
                      const temp = arr[replaceIndex]; // 
                      arr[replaceIndex] = arr[indexToReplace];
                      arr[indexToReplace] = temp;
                  
                      if(once) props.foundSceneFunc && props.foundSceneFunc();
                    } else {
                      name = name;
                      if(once) props.notFoundSceneFunc && props.notFoundSceneFunc();
                    }
                }
                let slideIndex = getSlideIndex(name, arr)
                setInitialSlide(slideIndex >= 0 ? slideIndex : 0)
                setModelbgList(arr)
                modelbgListRef.current = arr
                if(imageType == IMAGE_TYPE.MODEL) {
                    if(isDefaultStyle) {  // 避免模特模块两个组件赋值两次
                        setSelectedImg(name)
                        props.getSceneImg(name, version, 'init')
                    }
                } else {
                    setSelectedImg(name)
                    props.getSceneImg(name, version, 'init')
                }
            }
        }).catch((error) => {
            console.error(error)
        }).finally(() => {
            setLoading(false)
        })
    }, [props.refreshRecent, selectsceneType]);

    useEffect(() => {
        if(props.drawerSaveSelect?.length == 0) return
        selectModalSave(props.drawerSaveSelect[0].id, props.drawerSaveSelect[0].name, props.drawerSaveSelect[0].imageUrl, props.drawerSaveSelect[0].attr)
    }, [props.drawerSaveSelect])

    useEffect(() => {
        props.getDrawerDate(selectedImg)
    }, [selectedImg])

    const carouselRef = useRef()
    useEffect(() => {
        // 由于会从selectModal选择，需要自动跳转到对于的page
        let slideIndex = getSlideIndex(selectedImg)
        if (carouselRef.current && slideIndex >= 0) carouselRef.current.goTo(slideIndex, true)
    }, [modelbgList, selectedImg])

    useEffect(() => {
        if(props.title == '预设参考图') return
        // 纯色背景
        const solid_background = orginModelBgListRef.current 
            .filter(item => /solid_background/.test(item.name))
            .map(item => [...item.subList.filter(i => !/_solid_background_random$/.test(i.name)).map(i => i.name)])
            .flat()
        // 窗幔布艺
        const drapery_background = orginModelBgListRef.current
            .filter(item => /drapery_background/.test(item.name))
            .map(item => [...item.subList.filter(i => !/_drapery_background_random$/.test(i.name)).map(i => i.name)])
            .flat()
        // 没有subList的背景
        const no_subList_background = orginModelBgListRef.current
            .filter(item => (!/_random$/.test(item.name) && !/_keep$/.test(item.name) &&!/solid_background/.test(item.name) && !/drapery_background/.test(item.name)))
            .map(item => item.name)
        if (/_solid_background_random$/.test(selectedImg)) { // 纯色背景
            filteredBgListRef.current = solid_background
        } else if (/_drapery_background_random$/.test(selectedImg)) { // 窗幔布艺
            filteredBgListRef.current = drapery_background
        } else { // 包含所有的
            filteredBgListRef.current = [
                ...no_subList_background,
                ...solid_background,
                ...drapery_background
            ]
        }
    }, [selectedImg])
  
    const [direction, setDirection] = useState('left');
    useEffect(() => {
        if (props.definedFlag == 1) {
            setDirection('right')
        } else {
            setDirection('left')
        }
    }, [props.definedFlag])

    const onMoreSceneChange = (id, name, url, version) => {
        const arr = [...modelbgList];
        let found = false;
        for (let i = 0; i < arr?.length; i++) {
          if (arr[i].id == id) {
            arr[i].name = name;
            arr[i].imageUrl = url;
            found = true;
            break;
          }
        }
        setModelbgList([...arr]);
        setSelectedImg(name);
        props.getSceneImg(name, version);
    };
    
    const selectImgClick = (name, version) => {
        setSelectedImg(name);
        props.getSceneImg(name, version);
        
        let itemSelect = findItemByName(modelbgListRef.current, name);
        checkDrawerSelect(itemSelect);
    }

    const findItemByName = (list, name) => {
        for (let i = 0; i < list?.length; i++) {
          if (list[i].name === name) {
            return list[i];
          }
          if (list[i].subList) {
            const subItem = findItemByName(list[i].subList, name);
            if (subItem) {
              return list[i];
            }
          }
        }
        return undefined;
    };

    const checkDrawerSelect = (select) => {
        // 展示场景没有替换第一个
        if(!select) return
        let showLength = serachNum
        let replaceIndex = 1
        if(isDefaultStyle && imageType == IMAGE_TYPE.MODEL) {
            replaceIndex = 2
        } else {
            replaceIndex = 1
        }
        
        let slicedArray = modelbgList.slice(0, showLength);
        let itemExists = slicedArray.some(item => item.name == select.name);
        if (!itemExists) {
            let arr = [...modelbgList]
            arr[replaceIndex] = select
            setModelbgList(arr)
        }
    }

    const selectModalSave = ( id, name, imageUrl, attr) => {
     
        let found = false;
        for (let item of modelbgList) {
          if (item.id == id) {
            item.name = name;
            item.imageUrl = imageUrl;
            found = true;
            break;
          }
        }
        setModelbgList([...modelbgList]);
        selectImgClick(name, attr?.version);
    };

    const getSlideIndex = (name, arr = modelbgList) => {
        let slideNumber = -1;
        for (let index = 0; index < arr?.length; index++) {
          if (arr[index].name == name) {
            slideNumber = index;
            break;
          }
        }
        return slideNumber;
    };

    useEffect(() => {
        bgCategoryList()
    }, [])


    const bgCategoryList = () => {
        if(imageType != IMAGE_TYPE.COMMODITY) return
        API.bgCategoryList({
            type: IMAGE_TYPE.COMMODITY
        }).then(res => {
            if (res.code == 0) {
                const newData = {
                    data: '',
                    display: '全部',
                    value: '全部'
                }
                setBgCategoryData([newData, ...res.data])
            } else {
                message.warning(res.message)
            }
        })
    }

    const randomClick = (e) => {
        selectImgClick(modelbgList[0].name, modelbgList[0].attr.version)
    }

    const handleChange = (value) => {
        if(!value) return
        setSelectsceneType(value)
    };
    const handleClear = () => {
        setSelectsceneType('全部')
    }

    useEffect(() => {
        setSceneDirection(direction)
    }, [direction])
  
    return (
        <>
            {
                isDefaultStyle ? 
                <div className={styles.select_title} style={{marginTop: '20px'}}>
                    <span>选择场景</span>
                    <Checkbox disabled={direction == 'right'} checked={props.sceneName == '00_random'? true: false} onChange={randomClick}>随机</Checkbox>
                </div>: null
            }
            <div className={`${styles.SelectScene} ${direction == 'right'? styles.scene_change_tab_l: styles.scene_change_tab_r}`} style={{background: isDefaultStyle ?null: 'none'}}>
                {
                    isDefaultStyle?
                    <p className={`${styles.scene_change_tab}`}>
                        <span onClick={() => setDirection('left')}>预设场景</span>
                        <span
                            className={!customSceneAvailable ? styles.showIcon : null}
                            onClick={customSceneAvailable ? () => setDirection('right'): () => {}}
                        >
                            自定义场景
                            { imageType == IMAGE_TYPE.MODEL && <VersionTips version={2} isModel /> }
                        </span>
                    </p>: null
                }   
                {
                    direction == 'left'? <>
                    {
                        imageType == IMAGE_TYPE.MODEL?<p className={styles.scene_p}>{props.title}</p> : null
                    }
                    {
                        imageType == IMAGE_TYPE.COMMODITY?<Select
                        value={selectsceneType}
                        placement="bottomRight"
                        className={styles.select_bg}
                        popupClassName={styles.select_bg_popup}
                        onChange={handleChange}
                        allowClear
                        onClear={handleClear}
                        options={bgCategoryData}
                        fieldNames={{
                            label: 'display',
                            value: 'value',
                        }}
                        />: null
                    }
                    
                    <div className={styles.scene_select_img}>
                        {
                            !loading &&
                            modelbgList.map((item, index) => {
                                if(index > showNum) return
                                if(item.name != '00_random') {
                                    return <div key={index} className={styles.scene_select_img_box}>
                                        <SceneItem
                                            key={item.id}
                                            scene={item}
                                            selectedImg={selectedImg}
                                            selectImgClick={selectImgClick}
                                            onMoreSceneChange={onMoreSceneChange}
                                            sceneName={props.sceneName}
                                        />
                                    </div>
                                }
                            })
                        }
                        {
                            !loading &&
                            modelbgList.length > 0 &&
                            <div className={styles.moreItem} onClick={(e) => props.toggleDrawer(e, isDefaultStyle?'Scene': 'Scene2')}><p>更多 <i></i></p></div>
                        }
                        {
                            loading && <div className={styles.empty_wrap}><Spin /></div>
                        }
                        { 
                            !loading && modelbgList.length == 0 && <div className={styles.empty_wrap}><Empty /></div>
                        }
                    </div>
                    </>: isDefaultStyle?
                    <CustomScene
                        definedFlag={props.definedFlag}
                        positivePrompt={props.positivePrompt}
                        bkgUrl={props.bkgUrl}
                        sceneType={props.sceneType}
                        refVersion={props.refVersion}
                        refStrength={props.refStrength}
                        onChange={props.onCustomChange}
                    />: null
                }
            </div>
        </>
       
    )
}

export default SelectScene